import React from "react";
import type { Season } from "../api/types";
import { seasonSpan } from "../utils/seasonText";

/** Name and the one line that says what the season is. */
const SeasonHeader: React.FC<{ season: Season; children?: React.ReactNode }> = ({ season, children }) => (
  <header className="gm-head">
    <p className="gm-kicker">The game</p>
    <h1 className="gm-title">{season.name}</h1>
    <p className="gm-lead">
      {seasonSpan(season.totalDays, season.dayKeyFrom, season.dayKeyTo)} The best player outside the AOTD leaderboard top 3 takes an AOTD IRL.
    </p>
    {children}
  </header>
);

export default SeasonHeader;
